export const ConfigureShippingMethod = {
    syncShippingZones: 'syncShippingZones',
    createCheckoutPlusScript: 'createCheckoutPlusScript',
    deleteCheckoutPlusScript: 'deleteCheckoutPlusScript',
    checkoutPlusProducts: 'checkoutPlusProducts',
    bulkUpdateDiscounts: 'bulkUpdateDiscounts',
    removeGspCartScript: 'removeGspCartScript',
};
//# sourceMappingURL=configure.js.map